import { render, staticRenderFns } from "./product-video.vue?vue&type=template&id=1e6a1ba8&scoped=true&"
import script from "./product-video.vue?vue&type=script&lang=js&"
export * from "./product-video.vue?vue&type=script&lang=js&"
import style0 from "./product-video.vue?vue&type=style&index=0&id=1e6a1ba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6a1ba8",
  null
  
)

export default component.exports